import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Terms = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-gray-900 min-h-screen text-white">
      <header className="bg-gray-800 py-6 px-6">
        <div className="max-w-4xl mx-auto flex items-center">
          <Link to="/" className="flex items-center space-x-2 text-brand hover:text-brand-dark transition-colors">
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            <span>{t('header.backToTenku')}</span>
          </Link>
        </div>
      </header>

      <main className="py-12 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8">{t('legal.termsTitle')}</h1>

          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300 mb-6">
              <strong>{t('legal.lastUpdated')}</strong> {new Date().toLocaleDateString()}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('terms.section1.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('terms.section1.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('terms.section2.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('terms.section2.intro')}
              </p>
              <ul className="text-gray-300 space-y-2 ml-6">
                <li>• {t('terms.section2.find')}</li>
                <li>• {t('terms.section2.organize')}</li>
                <li>• {t('terms.section2.connect')}</li>
                <li>• {t('terms.section2.participate')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('terms.section3.title')}</h2>
              <p className="text-gray-300 mb-4">{t('terms.section3.intro')}</p>
              <ul className="text-gray-300 space-y-2 ml-6">
                <li>• {t('terms.section3.age')}</li>
                <li>• {t('terms.section3.accurate')}</li>
                <li>• {t('terms.section3.security')}</li>
                <li>• {t('terms.section3.notify')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('terms.section4.title')}</h2>
              <p className="text-gray-300 mb-4">{t('terms.section4.intro')}</p>
              <ul className="text-gray-300 space-y-2 ml-6">
                <li>• {t('terms.section4.respectful')}</li>
                <li>• {t('terms.section4.noOffensive')}</li>
                <li>• {t('terms.section4.noIllegal')}</li>
                <li>• {t('terms.section4.noHarass')}</li>
                <li>• {t('terms.section4.noFake')}</li>
                <li>• {t('terms.section4.noSpam')}</li>
                <li>• {t('terms.section4.ip')}</li>
                <li>• {t('terms.section4.noInterfere')}</li>
                <li>• {t('terms.section4.rules')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('terms.section5.title')}</h2>
              <p className="text-gray-300 mb-4">
                <strong>{t('terms.section5.important')}</strong> {t('terms.section5.intro')}
              </p>
              <ul className="text-gray-300 space-y-2 ml-6">
                <li>• {t('terms.section5.ownRisk')}</li>
                <li>• {t('terms.section5.insurance')}</li>
                <li>• {t('terms.section5.notResponsible')}</li>
                <li>• {t('terms.section5.recommend')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('terms.section6.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('terms.section6.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('terms.section7.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('terms.section7.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('terms.section8.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('terms.section8.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('terms.section9.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('terms.section9.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('terms.section10.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('terms.section10.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('terms.section11.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('terms.section11.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('terms.section12.title')}</h2>
              <p className="text-gray-300 mb-4">
                {t('terms.section12.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-brand">{t('terms.section13.title')}</h2>
              <p className="text-gray-300">
                {t('terms.section13.content')}
                <br />
                <strong>{t('terms.section13.email')}</strong>
              </p>
            </section>
          </div>
        </div>
      </main>

      <footer className="bg-gray-800 py-6 px-6 mt-12">
        <div className="max-w-4xl mx-auto text-center text-gray-400">
          <p>{t('footer.copyright')}</p>
        </div>
      </footer>
    </div>
  );
};

export default Terms;